module.exports = __webpack_public_path__ + "media/site/images/ecommerce/ecommerce-solutions-for-any-device.pl-9d39089136fe8db14a2ab916432cb8bf.png";